// extracted by mini-css-extract-plugin
export default {"paper":"WxEhPW9v7sQS1WJTtXMu","overflowHidden":"KJoarQSbWQbPqyD9Otq5"};